import { Image } from '@/app/_components/common/Image';
import { Link } from '@/app_components/common/Link';
import { formatDateTime } from '@/app_lib/utils/utils';

export interface PressReleaseCardProps {
  headline: string;
  excerpt: string;
  location: string;
  date: string;
  thumbnail: string;
  url: string;
}

export const PressReleaseCard = ({ headline, excerpt, location, date, thumbnail, url }: PressReleaseCardProps) => {
  return (
    <div
      className='flex pb-6 items-start gap-6 border-b stroke-secondary text-primary'
      data-cy='ez-newswire-press-release-card'
    >
      <div className='flex flex-col gap-1 flex-1'>
        <div
          className='font-graphik font-normal typography-xs text-primary'
          data-cy='ez-newswire-press-release-card-date-and-location'
        >
          {formatDateTime(date)} · {location}
        </div>
        <div className='flex flex-col gap-2'>
          <Link
            className='font-bold typography-default lg:typography-level-5 font-inria-serif hover:text-neutral-600'
            data-cy='ez-newswire-press-release-card-title'
            href={`/press-releases/${url}`}
          >
            {headline}
          </Link>
          <div
            className='hidden lg:[display:-webkit-box] overflow-hidden text-neutral-600 font-graphik-compact text-base font-normal leading-[140%] [-webkit-box-orient:vertical] [-webkit-line-clamp:3]'
            data-cy='ez-newswire-press-release-card-excerpt'
          >
            {excerpt}
          </div>
        </div>
      </div>
      <Link
        className='relative group w-[100px] lg:w-[266px] aspect-[3/2] overflow-hidden bg-helper'
        data-cy='ez-newswire-press-release-card-image'
        href={`/press-releases/${url}`}
      >
        <Image
          alt='Press Release thumbnail'
          className='object-contain object-center'
          fill
          fullWidth={false}
          src={thumbnail}
        />
        <div className='absolute inset-0 opacity-0 group-hover:opacity-100 bg-[linear-gradient(0deg,rgba(0,0,0,0.10)_0%,rgba(0,0,0,0.10)_100%)] pointer-events-none' />
      </Link>
    </div>
  );
};
